import React from 'react'

import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'
import useSSOContext, { NAV_MODALS } from 'main/hooks/useSSOContext'

export default function useNavContextModal(
  modalType: NAV_MODALS,
  locPathName: string,
): [boolean, () => void, () => void] {
  const ssoFlag = useFeatureFlag(Flags.SSO)
  const isSSO = ssoFlag.enabled()
  const { navContext, extendNavContext } = useSSOContext()
  const hasNavContextModal = !navContext?.isOnboarding && navContext?.modal === modalType
  const defaultDisplayModal = isSSO ? hasNavContextModal : false
  const [isModalOpen, setDisplayModal] = React.useState<boolean>(defaultDisplayModal)

  React.useEffect(() => {
    // react to post-mount state changes
    if (hasNavContextModal && !isModalOpen) {
      setDisplayModal(true) // on modal close, this will be unset and not run again
    }
  })

  const openModal = () => {
    setDisplayModal(true)
    extendNavContext(
      {
        modal: modalType,
      },
      locPathName,
    )
  }
  const closeModal = () => {
    extendNavContext(
      {
        modal: undefined,
      },
      undefined,
    )
    setDisplayModal(false)
  }

  return [isModalOpen, openModal, closeModal]
}
